import { render } from "./TreeNode.vue?vue&type=template&id=2e9252f1&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=2e9252f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9252f1"]])

export default __exports__